import React from 'react';
import { Box, Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { DestinationCardSkeleton } from 'views/common/components/UI/DestinationCard';

const MotorcycleTripsViewSkeleton = () => (
  <Box my={2}>
    <Skeleton variant="text" width="50%" height={50} />
    <Grid container spacing={4} pt={2}>
      {[...Array(6)].map((index) => (
        <Grid item xs={12} md={6} lg={4} key={index}>
          <DestinationCardSkeleton />
        </Grid>
      ))}
    </Grid>
  </Box>
);
export { MotorcycleTripsViewSkeleton };
